import { render, staticRenderFns } from "./TableScore.vue?vue&type=template&id=ae7f0f6a&scoped=true&"
import script from "./TableScore.vue?vue&type=script&lang=js&"
export * from "./TableScore.vue?vue&type=script&lang=js&"
import style0 from "./TableScore.vue?vue&type=style&index=0&id=ae7f0f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7f0f6a",
  null
  
)

export default component.exports